import React from 'react';
import PropTypes from 'prop-types';
import { bibShape, checkedOutItemShape } from '@bibliocommons/bc-prop-types';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import FulfilmentContent from './FulfilmentContent';

export default function FulfilmentModal({ bib, modalKey, accountId, checkoutItem, checkoutActions, modalActions }) {
  function handleClose() {
    modalActions.closeModal(modalKey);
  }

  return (
    <ModalContainer className="cp-fulfilment-modal" size="large" modalKey={modalKey} handleClose={handleClose}>
      <FulfilmentContent
        bib={bib}
        accountId={accountId}
        checkoutActions={checkoutActions}
        checkoutItem={checkoutItem}
      />
    </ModalContainer>
  );
}

FulfilmentModal.propTypes = {
  bib: bibShape.isRequired,
  modalKey: PropTypes.string.isRequired,
  accountId: PropTypes.number.isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutItem: checkedOutItemShape.isRequired
};
